import { useLanguage } from "../i18n/LanguageContext";
import { useEffect, useState } from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function NavBar() {
  const { t, language, setLanguage } = useLanguage();
  const [navbar, setNavbar] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const changeBackground = () => {
    if (window.scrollY >= 60) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    // scroll navbar config
    changeBackground();
    window.addEventListener("scroll", changeBackground);

    // Add event listener for clicks outside the menu
    const handleClickOutside = (event) => {
      if (menuOpen && !event.target.closest(".nav-bar")) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Cleanup event listener
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", changeBackground);
    };
  }, [menuOpen]);

  return (
    <div className={navbar ? "nav-bar scrolled" : "nav-bar"}>
      <Navbar expand="lg" expanded={menuOpen}>
        <Container fluid>
          <button
            type="button"
            className="language-switch"
            aria-label={t(
              language === "en"
                ? "language.switchToArabic"
                : "language.switchToEnglish",
            )}
            onClick={() => setLanguage(language === "en" ? "ar" : "en")}
            lang={language === "en" ? "ar" : "en"}
          >
            {t(language === "en" ? "language.arabic" : "language.english")}
          </button>
          <Navbar.Toggle
            label={t("nav.toggle")}
            aria-controls="responsive-navbar"
            onClick={toggleMenu}
          />
          <Navbar.Collapse id="responsive-navbar" in={menuOpen}>
            <Nav className="me-auto my-2" onClick={() => setMenuOpen(false)}>
              <Link className="nav-contents" to="/" key="home">
                {t("nav.home")}
              </Link>
              <Link className="nav-contents" to="/about" key="about">
                {t("nav.about")}
              </Link>
              <Link className="nav-contents" to="/skills" key="skills">
                {t("nav.skills")}
              </Link>
              <Link className="nav-contents" to="/experience" key="experience">
                {t("career.heading")}
              </Link>
              <Link className="nav-contents" to="/education" key="education">
                {t("learning.heading")}
              </Link>
              <Link className="nav-contents" to="/projects" key="projects">
                {t("nav.projects")}
              </Link>
              <Link className="nav-contents" to="/contact" key="contact">
                {t("nav.contact")}
              </Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
}
